import type { ForwardedRef } from 'react';

import { useEffect, useRef } from 'react';

/**
 * A hook to pass ForwardedRef to a child component defaulting to a local MutableRefObject.
 * @param {ForwardedRef<T>} ref - A ref prop from the parent component.
 * @param {any} [initialValue=null] - Optional initial value of the ref.
 * @returns - A ref that can be passed to the child component.
 */
export const useForwardRef = <T>(ref: ForwardedRef<T>, initialValue: any = null) => {
  const targetRef = useRef<T>(initialValue);

  useEffect(() => {
    if (!ref) return;

    if (typeof ref === 'function') ref(targetRef.current);
    else ref.current = targetRef.current;
  }, [ref]);

  return targetRef;
};
